<h2 mat-dialog-title class="av-section-title">{{ data.title | translate }}</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0" data-testid="reason-consequence">{{ data.consequence | translate }}</p>

  <dl class="d-flex flex-column gap-2 m-0">
    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.common.reason_dialog.organization' | translate }}</dt>
      <dd class="m-0 cell-strong text-end" data-testid="reason-organization">
        {{ data.organizationName }}
      </dd>
    </div>

    <div class="d-flex justify-content-between gap-3">
      <dt class="av-meta">{{ 'backoffice.billing.reason_dialog.document' | translate }}</dt>
      <dd class="m-0 text-end av-source" data-testid="reason-subject">{{ data.subjectLabel }}</dd>
    </div>
  </dl>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="document-reason">
      <span class="av-meta">{{ 'backoffice.licences.reason' | translate }}</span>
      <textarea
        id="document-reason"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
        data-testid="reason-input"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="dismiss()">{{ 'backoffice.common.actions.cancel' | translate }}</button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid"
    (click)="confirm()"
    data-testid="reason-submit"
  >
    {{ data.confirmLabel | translate }}
  </button>
</mat-dialog-actions>
